import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-61daa62e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "admin-team-container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Manage Team Members", -1))
const _hoisted_3 = {
  key: 0,
  class: "error"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Image"),
    /*#__PURE__*/_createElementVNode("th", null, "Name"),
    /*#__PURE__*/_createElementVNode("th", null, "Designation"),
    /*#__PURE__*/_createElementVNode("th", null, "Testimonial"),
    /*#__PURE__*/_createElementVNode("th", null, "Socials"),
    /*#__PURE__*/_createElementVNode("th", null, "Actions")
  ])
], -1))
const _hoisted_5 = ["src"]
const _hoisted_6 = ["onChange"]
const _hoisted_7 = ["onUpdate:modelValue"]
const _hoisted_8 = ["onUpdate:modelValue"]
const _hoisted_9 = ["onUpdate:modelValue"]
const _hoisted_10 = ["onUpdate:modelValue"]
const _hoisted_11 = ["value"]
const _hoisted_12 = ["onUpdate:modelValue"]
const _hoisted_13 = ["onUpdate:modelValue"]
const _hoisted_14 = ["onClick"]
const _hoisted_15 = ["onClick"]
const _hoisted_16 = ["onClick"]
const _hoisted_17 = ["onClick"]
const _hoisted_18 = ["src"]
const _hoisted_19 = ["onUpdate:modelValue"]
const _hoisted_20 = ["value"]
const _hoisted_21 = ["onUpdate:modelValue"]
const _hoisted_22 = ["onUpdate:modelValue"]
const _hoisted_23 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("button", {
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.logout && _ctx.logout(...args))),
      class: "logout-btn"
    }, "Logout"),
    (_ctx.error)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.error), 1))
      : _createCommentVNode("", true),
    _createElementVNode("table", null, [
      _hoisted_4,
      _createElementVNode("tbody", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.team, (member) => {
          return (_openBlock(), _createElementBlock("tr", {
            key: member.id
          }, [
            _createElementVNode("td", null, [
              _createElementVNode("img", {
                src: `http://localhost:5001/api/team/${member.id}/image`,
                alt: "img",
                width: "60"
              }, null, 8, _hoisted_5),
              _createElementVNode("input", {
                type: "file",
                onChange: e => _ctx.uploadImage(e, member)
              }, null, 40, _hoisted_6)
            ]),
            _createElementVNode("td", null, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": ($event: any) => ((member.name) = $event)
              }, null, 8, _hoisted_7), [
                [_vModelText, member.name]
              ])
            ]),
            _createElementVNode("td", null, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": ($event: any) => ((member.designation) = $event)
              }, null, 8, _hoisted_8), [
                [_vModelText, member.designation]
              ])
            ]),
            _createElementVNode("td", null, [
              _withDirectives(_createElementVNode("textarea", {
                "onUpdate:modelValue": ($event: any) => ((member.testimonial) = $event)
              }, null, 8, _hoisted_9), [
                [_vModelText, member.testimonial]
              ])
            ]),
            _createElementVNode("td", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(member.socials, (social, sidx) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: sidx,
                  class: "social-row"
                }, [
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": ($event: any) => ((social.icon) = $event)
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.socialIcons, (icon) => {
                      return (_openBlock(), _createElementBlock("option", {
                        value: icon.path,
                        key: icon.path
                      }, _toDisplayString(icon.label), 9, _hoisted_11))
                    }), 128))
                  ], 8, _hoisted_10), [
                    [_vModelSelect, social.icon]
                  ]),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": ($event: any) => ((social.url) = $event),
                    placeholder: "URL"
                  }, null, 8, _hoisted_12), [
                    [_vModelText, social.url]
                  ]),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": ($event: any) => ((social.alt) = $event),
                    placeholder: "Alt"
                  }, null, 8, _hoisted_13), [
                    [_vModelText, social.alt]
                  ]),
                  _createElementVNode("button", {
                    onClick: ($event: any) => (_ctx.removeSocial(member, sidx))
                  }, "Remove", 8, _hoisted_14)
                ]))
              }), 128)),
              _createElementVNode("button", {
                onClick: ($event: any) => (_ctx.addSocial(member))
              }, "Add Social", 8, _hoisted_15)
            ]),
            _createElementVNode("td", null, [
              _createElementVNode("button", {
                onClick: ($event: any) => (_ctx.updateMember(member))
              }, "Save", 8, _hoisted_16),
              _createElementVNode("button", {
                onClick: ($event: any) => (_ctx.deleteMember(member.id))
              }, "Delete", 8, _hoisted_17)
            ])
          ]))
        }), 128)),
        _createElementVNode("tr", null, [
          _createElementVNode("td", null, [
            (_ctx.newMember.image_blob_preview)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  src: _ctx.newMember.image_blob_preview,
                  alt: "img",
                  width: "60"
                }, null, 8, _hoisted_18))
              : _createCommentVNode("", true),
            _createElementVNode("input", {
              type: "file",
              onChange: _cache[1] || (_cache[1] = e => _ctx.uploadImage(e, _ctx.newMember))
            }, null, 32)
          ]),
          _createElementVNode("td", null, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.newMember.name) = $event)),
              placeholder: "Name"
            }, null, 512), [
              [_vModelText, _ctx.newMember.name]
            ])
          ]),
          _createElementVNode("td", null, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.newMember.designation) = $event)),
              placeholder: "Designation"
            }, null, 512), [
              [_vModelText, _ctx.newMember.designation]
            ])
          ]),
          _createElementVNode("td", null, [
            _withDirectives(_createElementVNode("textarea", {
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.newMember.testimonial) = $event)),
              placeholder: "Testimonial"
            }, null, 512), [
              [_vModelText, _ctx.newMember.testimonial]
            ])
          ]),
          _createElementVNode("td", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.newMember.socials, (social, sidx) => {
              return (_openBlock(), _createElementBlock("div", {
                key: sidx,
                class: "social-row"
              }, [
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": ($event: any) => ((social.icon) = $event)
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.socialIcons, (icon) => {
                    return (_openBlock(), _createElementBlock("option", {
                      value: icon.path,
                      key: icon.path
                    }, _toDisplayString(icon.label), 9, _hoisted_20))
                  }), 128))
                ], 8, _hoisted_19), [
                  [_vModelSelect, social.icon]
                ]),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": ($event: any) => ((social.url) = $event),
                  placeholder: "URL"
                }, null, 8, _hoisted_21), [
                  [_vModelText, social.url]
                ]),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": ($event: any) => ((social.alt) = $event),
                  placeholder: "Alt"
                }, null, 8, _hoisted_22), [
                  [_vModelText, social.alt]
                ]),
                _createElementVNode("button", {
                  onClick: ($event: any) => (_ctx.removeSocial(_ctx.newMember, sidx))
                }, "Remove", 8, _hoisted_23)
              ]))
            }), 128)),
            _createElementVNode("button", {
              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.addSocial(_ctx.newMember)))
            }, "Add Social")
          ]),
          _createElementVNode("td", null, [
            _createElementVNode("button", {
              onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.addMember && _ctx.addMember(...args)))
            }, "Add")
          ])
        ])
      ])
    ])
  ]))
}